module.exports = __webpack_public_path__ + "static/_spsaLogo-b9d1797787205c23a484e733434077a8.png";